import {DataFilterExtension} from '@deck.gl/extensions';
import {LAYERS_ID, LAYERS_SQL} from './constants';
import {IconLayer} from '@deck.gl/layers';
import {BaseLayerMVTDeck} from '../../../common/layers/baseLayerMVTDeck';
import {MvtService} from '../../../common/services/mvt.service';
import {RealTimePopupComponent} from '../../../real-time/real-time/real-time-popup/real-time-popup.component';

export class UpcomingLayer extends BaseLayerMVTDeck {

    private visibleLayerByDefault = ['\'NODATA\''];
    features = {};
    icon_mapping: any;
    icon_atlas = '';

    layers = {
        [LAYERS_ID.UPCOMING_INFORMO_LAYER]: (
            new IconLayer({
                id: LAYERS_ID.UPCOMING_INFORMO_LAYER,
                pickable: true,
                onClick: (f) => this._clickOnLayer(f),
                onHover: ({object}) => this.hover(object !== undefined),
                getPosition: d => d.geometry.coordinates,
                getSize: this.getSize(),
                iconAtlas: 'assets/sprite/markers@3x.png',
                iconMapping: 'assets/sprite/markers@3x.json',
                getIcon: (f) => this.getIcon(f.properties),
                getFilterValue: d => {
                    return [
                        Number(this.visibleLayerByDefault.includes(d.properties.type)),
                    ];
                },
                filterRange: [
                    [1, 1],
                ],
                extensions: [new DataFilterExtension({filterSize: 1})],
                updateTriggers: {
                    getFilterValue: [
                        this.visibleLayerByDefault,
                    ]
                }
            })
        ),
    };

    constructor(
        private city,
        private mvtService: MvtService
    ) {
        super(LAYERS_ID.UPCOMING_INFORMO_LAYER);
        this.mvtService.getIconAtlas().then(i => {
            this.icon_atlas = i.atlas;
            this.icon_mapping = i.mapping;
        });
    }

    getDataLayer() {
        const p = [];
        Object.keys(this.layers).forEach(layer_id => {
            const tiles = this.mvtService.getMVT(
                layer_id,
                LAYERS_SQL[layer_id]()
            );

            p.push(tiles);
        });

        return Promise.all(p).then(values => {
            return Object.keys(this.layers).map((id, idx) => {
                const layerInfo = {
                    id,
                    tiles: values[idx]
                }

                this.features[id] = values[idx].features

                return layerInfo
            });
        });
    }

    _clickOnLayer(event) {
        if (event.object) {
            const popup = RealTimePopupComponent;

            const featureClicked = event.object;

            const typeName = 'PREVISION';

            const startDate = new Date(featureClicked.properties.start_timestamp * 1000).toISOString();
            const finishDate = new Date(featureClicked.properties.finish_timestamp * 1000).toISOString();

            const properties = {
                type: typeName,
                start: startDate,
                finish: finishDate,
                reportdescription: featureClicked.properties.reportdescription,
            };

            this.openPopup(properties, popup, {lng: event.coordinate[0], lat: event.coordinate[1]});
        }
    }

    updateFilters(city) {
        return new Promise((resolve, reject) => {
            this.city = city;
            this.setLayerFilters();
            this.update(LAYERS_ID.UPCOMING_INFORMO_LAYER, {
                updateTriggers: {
                    getFilterValue: [
                        this.visibleLayerByDefault,
                    ]
                }
            });
            resolve(this.readViewPortFeatures());
        });
    }

    setLayerFilters() {
        const city = this.city.find(c => c.mode === 'upcoming');
        this.visibleLayerByDefault = city.types
            .filter(type =>
                [
                    'PREVISION',
                ].includes(type.idText) && type.showing
            ).map(type => type.idText);
    }

    protected readViewPortFeatures() {
        const types = [
            {
                layer: LAYERS_ID.UPCOMING_INFORMO_LAYER,
                types: ['PREVISION'],
            },
        ];

        const mode = 'upcoming';
        const city = this.city.find(c => c.mode === mode);

        for (const type of types) {
            const features: any = Object.keys(this.features).map(key => this.features[key])

            this.countGeoJsonViewportFeatures({
                features: features.flat(),
                city,
                layerId: type.layer,
                allowed: type.types,
                variable: 'types',
                groupByLayer: 'type'
            })
        }

        return city;
    }

    getSize() {
        if (!this.mapContext || !this.mapContext.mapInstance) {
            return 32
        }

        const zoom = this.mapContext.mapInstance.getZoom();
        const minZoom = Math.pow(2, 10 - 1);
        const maxZoom = Math.pow(2, 14 - 1);
        
        return (minZoom < zoom && maxZoom > zoom ? 24 : 16) * 2;
    }

    getIcon(properties) {
        const values = ['future', 'current'];
        const idx = values.indexOf(properties.status);
        const images = [
            'misc-city-upcoming',
            'misc-madrid'
        ];
        return images[idx];
    }


}



// WEBPACK FOOTER //
// ./src/app/cities/informo/layers/upcomingLayer.ts